import { useTranslation } from "react-i18next";
import Button from "../../Button/Button";
import { useVenuesDataStore } from "@/store/useVenuesDataStore";
import { useParams } from "react-router-dom";
import useOnClickFunctions from "../helpers/onClickFunctions";

function ReceiptSent() {
  const { t } = useTranslation();
  const { handleNavigate } = useOnClickFunctions();
  const { restaurantId } = useParams();
  const { tableId } = useVenuesDataStore();

  return (
    <Button
      onClick={() =>
        handleNavigate(`/restaurants/${restaurantId}/tables/${tableId}`)
      }
      label={t("transparentDrawer.button.goBack")}
      variant="contained"
      color="primary"
      maxWidth
      mobile={true}
    />
  );
}

export default ReceiptSent;
